import React, { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import TopHeader from "../TopHeader";
import SearchIcon from "@material-ui/icons/Search";

import LeftIcon from "@material-ui/icons/ArrowBackIos";
import RightIcon from "@material-ui/icons/ArrowForwardIos";
import MoreIcon from "@material-ui/icons/MoreVert";
import Toast from "../../../components/Notify/Toast";
import ButtonBase from "@material-ui/core/ButtonBase";
import { BeatLoader } from "react-spinners";
import CreativesRows from "../Tabs/TableRows/Creatives";

import axiosInstance from "../../../utils/config";
import RenderCustomerUserProfile from "../../../components/CustomUserProfile/userProfile";

function Creatives(props) {
  const lastLogin = "14/APR/2020"; // template
  const [creativesLoading, setCreativesLoading] = useState(false);
  const [creatives, setCreatives] = useState([]);
  const [originalCreatives, setOriginalCreatives] = useState([]);
  const [isSigningIn, setSigningIn] = useState({ id: "", status: false });
  const [toastMessage, setToast] = useState("");
  const history = useHistory();
  const [totalDesigns, setTotalDesigns] = useState(0);
  const [remainingDesigns, setRemainingDesigns] = useState(0);

  const handleSearch = (value) => {
    if (value?.length > 0) {
      let searchResults = creatives?.filter((creative) =>
        creative?.Names?.toLowerCase().includes(value?.toLowerCase())
      );
      setCreatives(searchResults);
    } else {
      setCreatives(originalCreatives);
    }
  };

  const loginAccount = (id) => {
    setSigningIn({ id, status: true });
    const headers = {
      "Content-Type": "application/json",
      Authorization: "Bearer " + props.token,
    };
    axiosInstance
      .post("/admin/accounts/login", { userId: id }, { headers })
      .then((data) => {
        setToast(data.data.message);
        localStorage.setItem("skiUserToken", data.data.token.split(" ")[1]);
        history.push("/creative-home");
        setSigningIn(false);
      })
      .catch((err) => {
        setToast(err.response.data);
        setSigningIn(false);
      });
  };

  useEffect(() => {
    // Get all clients
    setCreativesLoading(true);
    const headers = {
      "Content-Type": "application/json",
      Authorization: `Bearer ${props.token}`,
    };
    axiosInstance
      .get("/creatives/all", { headers })
      .then((data) => {
        setCreatives(data.data.data);
        setOriginalCreatives(data.data.data);

        axiosInstance
          .get("/stats​/creatives​/templates", { headers })
          .then((data) => {
            console.log(data);
          });

        // let totalDesigns = 0;
        // data.data.data?.map((user) => (totalDesigns += user.downloads));
        // setTotalDesigns(totalDesigns);

        // let remainingDesigns = 0;
        // data.data.data?.map((user) => {
        //     remainingDesigns += user.downloads;
        // });
        // setRemainingDesigns(remainingDesigns);

        setCreativesLoading(false);
      })
      .catch((err) => {
        console.log(err.message);
        setCreativesLoading(false);
      });
  }, []);

  return (
    <div className="align-items-start d-flex flex-column left-side-container">
      {toastMessage && <Toast message={toastMessage} />}
      <div className="d-flex align-items-center justify-content-between admin-top-nav shadow-sm">
        <div className="left-container">
          <h3 className="stats-header-name">
            <b>Creatives</b>
          </h3>
          <p className="under-stats-name">Statistics</p>
        </div>
        <div className="d-flex flex-row right-container">
          <div className="d-flex flex-column justify-content-end admin-info">
            <h5 className="admin-name">
              <b>{props.currentUser.Names}</b>
            </h5>
            <p className="user-role">Admin</p>
          </div>
          <div className="admin-profile-cont">
            <img
              className="admin-profile-pic"
              src="/Images/Okolie.png"
              alt="admin pic"
            />
          </div>
        </div>
      </div>
      <TopHeader
        stats1={`${
          !creativesLoading ? (creatives?.length ? creatives.length : 0) : "--"
        } Creatives`}
        stats2={`${!creativesLoading ? totalDesigns : "--"} Designs`}
        stats3={`${!creativesLoading ? remainingDesigns : "--"} Designs`}
      />
      <div className="under-header d-flex justify-content-between align-items-end mb-2">
        <h6>
          <b>All</b>
        </h6>
        <button
          className="btn btn-primary btn-sm px-3 shadow-sm"
          onClick={() => {
            props.setPopupDisplay("flex");
          }}
        >
          add +
        </button>
      </div>
      <div className="table-container shadow-sm">
        <div className="horizontal-line"></div>
        <div className="search-container d-flex align-items-center">
          <SearchIcon style={{ marginLeft: "0.7em", color: "#1D8CFB" }} />
          <input
            type="text"
            placeholder="Search Designers by Names, or Sales"
            className="table-search-input"
            onChange={(e) => handleSearch(e.target.value)}
          />
        </div>
        <table className="admin-table">
          <thead>
            <th>
              <input type="checkbox" className="table-checkbox" />
            </th>
            <th>PICTURE</th>
            <th>NAME</th>
            <th>STATUS</th>
            <th>E-MAIL</th>
            <th>DESIGNS</th>
            <th>EARNING</th>
            <th>ACTION</th>
          </thead>
          <tbody>
            {creatives &&
              creatives?.map((creative, index) => (
                <tr key={index}>
                  <td>
                    <input type="checkbox" className="table-checkbox" />
                  </td>
                  <td>
                    {creative.profilePicture ? (
                      <img
                        src={creative.profilePicture}
                        className="admin-table-pic"
                        alt="Admin table pic"
                      />
                    ) : (
                      <RenderCustomerUserProfile
                        profile={creative.profileBackgroundColor}
                      />
                    )}
                  </td>
                  <td>{creative.Names}</td>
                  <td>
                    <small className="admin-table-status innactive">
                      Innactive
                    </small>
                    <br />
                    <small className="admin-table-last-login">
                      Last login: {lastLogin}
                    </small>
                  </td>
                  <td>{creative.Email}</td>
                  <td>0</td>
                  <td>
                    {" "}
                    <span className="remaining earnings">0</span>
                  </td>
                  <td>
                    {isSigningIn.id ? (
                      isSigningIn.status && isSigningIn.id == creative?._id ? (
                        <BeatLoader color="#1D8CFB" size={10} />
                      ) : (
                        <div className="">
                          <button
                            disabled={isSigningIn?.status}
                            type=""
                            className="shadow-sm btn dropdown-toggle"
                            data-toggle="dropdown"
                            aria-haspopup="true"
                            aria-expanded="false"
                          >
                            <MoreIcon
                              style={{ cursor: "pointer", color: "#1D8CFB" }}
                            />
                          </button>
                          <div className="dropdown-menu">
                            <button
                              className="dropdown-item"
                              onClick={() => loginAccount(creative?._id)}
                            >
                              Login
                            </button>
                          </div>
                        </div>
                      )
                    ) : (
                      <div className="">
                        <button
                          disabled={isSigningIn?.status}
                          type=""
                          className="shadow-sm btn dropdown-toggle"
                          data-toggle="dropdown"
                          aria-haspopup="true"
                          aria-expanded="false"
                        >
                          <MoreIcon
                            style={{ cursor: "pointer", color: "#1D8CFB" }}
                          />
                        </button>
                        <div className="dropdown-menu">
                          <button
                            className="dropdown-item"
                            onClick={() => loginAccount(creative?._id)}
                          >
                            Login
                          </button>
                        </div>
                      </div>
                    )}
                  </td>
                </tr>
              ))}
            {!creativesLoading && !creatives?.length && (
              <h5 className="no-results mt-2">No creative found</h5>
            )}
            {creativesLoading && !creatives?.length && (
              <>
                <tr style={{ width: "100%", height: "50px" }}></tr>
                <tr style={{ width: "100%", height: "50px" }}></tr>
                <tr style={{ width: "100%", height: "50px" }}></tr>
                <tr style={{ width: "100%", height: "50px" }}></tr>
              </>
            )}
          </tbody>
          {creatives?.length > 0 && (
            <tfoot>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td className="admin-table-footer">
                <b>Rows per page: 10</b>
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                <b>1-10 of 276</b>
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                <b>
                  <ButtonBase>
                    <LeftIcon fontSize="small" />
                  </ButtonBase>
                </b>
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                <b>
                  <ButtonBase>
                    <RightIcon fontSize="small" />
                  </ButtonBase>
                </b>
              </td>
              <td></td>
              <td></td>
              <td></td>
            </tfoot>
          )}
          <tfoot>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td className="admin-table-footer">
              <b>Rows per page: 10</b>
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
              <b>1-10 of 276</b>
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
              <b>
                <ButtonBase>
                  <LeftIcon fontSize="small" />
                </ButtonBase>
              </b>
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
              <b>
                <ButtonBase>
                  <RightIcon fontSize="small" />
                </ButtonBase>
              </b>
            </td>
            <td></td>
            <td></td>
            <td></td>
          </tfoot>
        </table>
      </div>
    </div>
  );
}

export default Creatives;
